module.exports = __webpack_public_path__ + "media/images/xpass/icons/close-3285ab6d0c32a65f457cf42adc37de16.svg";